
import { axios } from "@/redux/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const GetPaymentsThunk = createAsyncThunk(
  "payment",
  async (data: any = {}, { rejectWithValue }) => {
    try {
  
      const res = await axios.get("/v1/transactions", {
        headers: { "Content-Type": "application/json" },
        params: data,
      });

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const InitiatePaymentThunk = createAsyncThunk(
  "payment/init",
  async (data: any = {}, { rejectWithValue }) => {
    try {
  
      const res = await axios.post("https://api.winbigmalawi.com/api/v1/payment/init",data);

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
